import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '../enums/app-routes.enum';
import { AppHelper, CurrentAppType, EnvironmentName } from '@smartcare/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrowserDataService {
  private SERIALIZED_ES5_FUNCTION_PREFIX = '_es5Func_';
  private SERIALIZED_ES6_FUNCTION_FUNCTION = '_es6Func_';
  private router = inject(Router);

  static redirectToSelectedApp(application: CurrentAppType): void {
    if (environment.name === EnvironmentName.Local) {
      console.warn('In production will redirect to APP [CLEAR YOUR LOCALSTORAGE]');

      return;
    }

    AppHelper.getAppRedirectUrl(application);
  }

  setLocalStorage(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
      // notifyAll(key, value); //TODO check if we still need it
    } catch {
      // this.createCookie(key, value); //TODO check if we still need it
    }
  }

  setSessionStorage(key: string, value: unknown): void {
    //store the entire value in a JSON to avoid value type check. For example if the value is a string the JSON.stringify(value)
    // will return the "value" but JSON.parse(<session storage> will not work anymore.
    sessionStorage.setItem(key, this.stringify(value));
  }

  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate([AppRoutes.login]);
  }

  private stringify(data: unknown): string {
    return JSON.stringify({
      value: data
    }, (key, value) => {
      if (value instanceof Function || typeof value == 'function') {
        const fnBody = value.toString();
        const fnType = fnBody.length < 8 || fnBody.substring(0, 8) !== 'function' ? this.SERIALIZED_ES6_FUNCTION_FUNCTION : this.SERIALIZED_ES5_FUNCTION_PREFIX;
        if (fnType === this.SERIALIZED_ES5_FUNCTION_PREFIX) {
          return fnType + fnBody;
        } else {
          // arrow functions cannot be serialized
          return null;
        }
      }

      return value;
    });
  }
}
